import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'ui-kit-time-range',
    templateUrl: 'time-range.component.html',
    styleUrl: 'time-range.component.scss',
    standalone: false
})
export class TimeRangeComponent {
    @Input() startControl: FormControl<string>;
    @Input() endControl: FormControl<string>;
}
